/*=============================================== ProgressCirclePage ===============================================*/

import { ProgressCircle, getRandomNumber } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const ProgressCirclePage = () => {
    const randomNumber = getRandomNumber()

    const items: ItemType[] = [
        {
            content: <ProgressCircle value={randomNumber} showValue />,
            code: `<ProgressCircle value={${randomNumber}} showValue />`,
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "value",
            type: "number",
            required: true,
        },
        {
            subtitle: "color",
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
        {
            subtitle: "animated",
            type: "boolean",
            default: "true",
        },
        {
            subtitle: "showValue",
            intro: (
                <>
                    Only if <code>icon</code> is not defined.
                </>
            ),
            type: "boolean",
        },
        {
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ProgressCirclePage
